import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../Layouts/AuthLayout.vue"),
    redirect: "/login",
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/auth/login.vue"),
      },
      {
        path: "/contactus",
        name: "contactus",
        component: () => import("../views/contactus/index.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: "/login",
  },
  {
    path: "/dashboard",
    component: () => import("../Layouts/AdminLayout.vue"),
    redirect: "/main",
    meta: { requiresAuth: true }, // 👈 Authentication Required
    children: [
      {
        path: "/main",
        component: () => import("../views/dashboard/index.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/main1",
        component: () => import("../views/dashboard/dashbaord1.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/users",
        component: () => import("../views/users/index.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/broker",
        component: () => import("../views/broker/index.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/realtor",
        component: () => import("../views/realtor/index.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/notification",
        component: () => import("../views/notification/index.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/template",
        name: "template",
        component: () => import("../views/template/index.vue"),
      },
      {
        path: "/template/tasks",
        name: "temptasks",
        component: () => import("../views/template/tasks.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 🚀 Navigation Guard for Authentication & Logout Handling
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("broker-admin-token");

  // ✅ If user navigates to login page, clear localStorage and prevent back navigation
  if (to.path === "/login") {
    localStorage.clear();
    setTimeout(() => {
      window.history.replaceState(null, null, window.location.href);
    }, 0);
    if (!localStorage.getItem("app_version")) {
      localStorage.setItem("app_version", process.env.VUE_APP_VERSION);
    }
    return next();
  }

  // 🔒 Protect routes that require authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!token) {
      return next("/login"); // Redirect to login if no token found
    }
  }

  next();
});

export default router;
